import * as React from 'react';
import { Alert } from 'lib/alert/models';
import Flex from 'ui/Flex/Flex';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'helpers/dateHelper';
import AlertActions from './AlertActions';
import AlertBadge from './AlertStatus/AlertBadge';
import { capitalize } from 'helpers/helpers';

type Props = {
    alert: Alert;
    chartKey: number;
    onClick: () => void;
    isSubscribedAlert?: boolean;
};

const StyAlertPreview = styled(Flex, {
    name: 'StyAlertPreview',
})(({ theme }) => ({
    borderRadius: '3px',
    borderBottom: '1px solid #f8f8f8',
    '&:hover': {
        backgroundColor: theme.palette.lightGrey,
    },
}));

const AlertPreview = ({
    alert,
    chartKey,
    onClick,
    isSubscribedAlert = false,
}: Props) => {
    const { t } = useTranslation();

    return (
        <StyAlertPreview align="center" justify="center">
            <Box
                flexGrow={1}
                display="flex"
                style={{ cursor: 'pointer', padding: '1rem' }}
                onClick={onClick}
            >
                <AlertBadge status={alert.status} />
                <Box flexGrow={1} sx={{ ml: '1rem' }}>
                    <Typography variant="body1SemiBold">
                        {capitalize(alert.name)}
                    </Typography>
                    {alert.lastUpdatedAt && (
                        <Typography variant="body1">
                            {capitalize(
                                t('alert.list.updatedAt', {
                                    date: formatDate(
                                        new Date(alert.lastUpdatedAt),
                                    ),
                                }),
                            )}
                        </Typography>
                    )}
                </Box>
            </Box>
            <AlertActions
                alert={alert}
                chartKey={chartKey}
                isSubscribedAlert={isSubscribedAlert}
            />
        </StyAlertPreview>
    );
};

export default AlertPreview;
